import { useContext } from "react";

import { ScenarioBuilderContext } from "../context/ScenarioBuilderContextProvider";

export const useScenarioBuilderClient = () => {
  const scenarioBuilderContext = useContext(ScenarioBuilderContext);

  if (!scenarioBuilderContext) {
    throw new Error(
      "useScenarioBuilderClient must be used within a ScenarioBuilderContextProvider"
    );
  }

  return scenarioBuilderContext.scenarioBuilderClient;
};
